var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7517 4.90069C10.7517 3.86616 10.3408 2.87401 9.60924 2.14249C8.87772 1.41096 7.88556 1 6.85104 1C5.81651 1 4.82435 1.41096 4.09283 2.14249C3.36131 2.87401 2.95035 3.86616 2.95035 4.90069C2.95035 9.4515 1 10.7517 1 10.7517H12.7021C12.7021 10.7517 10.7517 9.4515 10.7517 4.90069Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97547 12.3521C7.86118 12.5491 7.69712 12.7126 7.49974 12.8263C7.30235 12.94 7.07856 12.9999 6.85077 12.9999C6.62299 12.9999 6.3992 12.94 6.20181 12.8263C6.00443 12.7126 5.84037 12.5491 5.72607 12.3521",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBadge);
export default __webpack_public_path__ + "static/media/bell-badge.593e7ff9.svg";
export { ForwardRef as ReactComponent };